export default {
  label: {
    open: 'Opening',
    waiting: 'Waiting',
    answer: 'Response',
    finished: 'Finished',
  },
  date: {
    month: 'month',
    day: 'day',
    hour: 'hour',
    minute: 'minute',
    second: 'second',
    default: '0 days 0 hours',
  },
};
